import { render, staticRenderFns } from "./EditPeople.vue?vue&type=template&id=b2ca5ef8&"
import script from "./EditPeople.vue?vue&type=script&lang=js&"
export * from "./EditPeople.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports